import { useQuery } from '@apollo/client';

import { GetSixtFocusmodeDocument } from './get-sixt-focusmode.gql-types';

type SixtFocusmodeResult = {
  isSixtFocusmodeAvailable: boolean;
  isSixtFocusmodeState: boolean | undefined;
  isSixtFocusmodeEnabled: boolean | undefined;
};

export const useSixtFocusmode = (): SixtFocusmodeResult => {
  const { data } = useQuery(GetSixtFocusmodeDocument);

  const coreSettings = data?.viewer?.coreSettings;
  const isSixtFocusmodeAvailable =
    coreSettings?.sixtFocusmodeAvailable?.value ?? false;
  const isSixtFocusmodeState = coreSettings?.sixtFocusmodeState?.value;

  const isSixtFocusmodeEnabled =
    isSixtFocusmodeAvailable && isSixtFocusmodeState;

  return {
    isSixtFocusmodeAvailable,
    isSixtFocusmodeState,
    isSixtFocusmodeEnabled,
  };
};
